import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import _uniqueId from 'lodash/uniqueId';
import Briciole from '../shared/briciole/Briciole';
import MagazineItem from '../shared/magazineItem/MagazineItem';

const MagazineDetail = () => {
	const pageContent = useSelector((state) => state.currentPage.pageContent);
	const magazinesHome = useSelector((state) => state.magazinesHome);
	const paginestaticheTranslation = useSelector(
		(state) => state.translations.paginestatiche
	);

	// local state

	useEffect(() => {}, []);

	// controllo che esista la proprietà detail (altrimenti vuol dire che sto ancora recuperando i dati)
	if (!pageContent.detail) {
		return <div></div>;
	}

	const elencoMagazinesHome =
		magazinesHome?.length > 0 &&
		magazinesHome.map((magazine) => (
			<MagazineItem key={_uniqueId('magazine_')} {...magazine} />
		));

	return (
		<div className='col-start-1 lg:col-start-15 4xl:col-start-16 col-end-61 3xl:col-end-59 4xl:col-end-57 sm:pb-12'>
			<Briciole />
			<div className='grid grid-cols-60 mt-0 sm:mt-3 xl:mt-6'>
				<div className='col-span-60 flex justify-between items-center px-8 xl:px-12 3xl:px-20 xl:pt-8 pb-6 sm:pb-8 xl:pb-12 3xl:py-14'>
					<h1 className='text-ribola-congress-blue text-3xl md:text-4xl xl:text-5xl font-opensansbold'>
						<small className='leading-tight flex'>
							{paginestaticheTranslation.titolomagazine.itemName.toUpperCase()}
						</small>
					</h1>
				</div>
				<div className='col-span-60 bg-ribola-gallery-gray px-8 xl:px-12 3xl:px-20 py-8 xl:py-12'>
					<h3 className='text-ribola-dove-gray text-xl md:text-2xl xl:text-3xl font-opensansbold mb-8'>
						<span className='leading-tight flex'>
							{paginestaticheTranslation.titolomagazineinterno.itemName.toUpperCase()}
						</span>
					</h3>
					<p
						className='text-sm'
						dangerouslySetInnerHTML={{
							__html:
								paginestaticheTranslation.descrizionemagazineinterno.itemName,
						}}></p>
				</div>
			</div>
			<div className='grid grid-cols-60 pb-8 sm:pb-20 mt-8 sm:mt-20'>
				{elencoMagazinesHome}
			</div>
		</div>
	);
};

export default MagazineDetail;
